import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function SidebarSectionError() {
    return (<Alert appearance="danger" message={t({
            message: 'An error occurred trying to get the information.',
            comment: 'Error message displayed when there is a error loading document information sidebar.',
        })}/>);
}
